import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { toast } from 'react-toastify';
import { CommonMinisterReligionCrumbs } from 'civil-status/constants/place';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import FormPlace from 'civil-status/components/place/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformRequest, transformResponse } from 'civil-status/utils/place';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';

const MinisterReligionEditPage = (): React.ReactElement => {
  const params = useParams();

  const [ministerReligionData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/${DomainType.MinisterReligion}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'get',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = ministerReligionData.data as PlaceForm;

  const editMinisterReligion = useHttpClient(`${__ACT_API_URL__}/valori-dominio-atti/update`, {
    options: {
      method: 'PUT',
      loading: true,
      errorCatching: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: PlaceForm) => {
      const data = transformRequest(
        formValues,
        DomainType.MinisterReligion,
        DomainType.ReligiousCults
      );
      (
        editMinisterReligion({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/ministro-culto');
      });
    },
    [editMinisterReligion, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonMinisterReligionCrumbs, { name: 'Modifica ministro di culto' }]}
      />
      {ministerReligionData.isLoading ||
      ministerReligionData.pristine ||
      ministerReligionData.error ? undefined : (
        <FormPlace
          title="Modifica ministro di culto"
          onSave={onSubmit}
          initialValues={values}
          isEdit
          isMinisterReligion
        />
      )}
    </Fragment>
  );
};

MinisterReligionEditPage.displayName = 'Minister Religion edit page component';

export default MinisterReligionEditPage;
